export default __webpack_public_path__ + "static/media/JBBLogo.fe2d3b02.jpg";